import { UserSnapshot } from 'app/store/user'

export type StartLoginResult =
  | {
      ok: true
      data: UserSnapshot
    }
  | {
      ok: false
      error: { type: 'cancel' | 'error'; message: string }
    }

/**
 * Web version of the auth session login hook
 *
 * On web, we use the server-side auth flow via /api/auth/login instead of
 * expo-auth-session. This hook provides a compatible interface.
 */
export function useAuthSessionLogin() {
  const startLogin = async (): Promise<StartLoginResult> => {
    // On web, redirect to the server-side auth endpoint
    const currentPath = typeof window !== 'undefined' ? window.location.pathname : '/'
    window.location.href = `/api/auth/login?returnPath=${encodeURIComponent(currentPath)}`
    // This will never resolve because the page redirects
    return { ok: true, data: {} as any }
  }

  return {
    startLogin,
    ready: true,
  }
}
